module.exports = __webpack_public_path__ + "static/media/3.827453b1.png";